// Shared below-video control row used by htmlVideoPlayer and imaVastPlayer:
// play/pause, mute, a current/duration time readout and a display-only progress bar.
// The parent owns playback; this component is presentational and reports clicks back
// via the on-play-pause / on-mute callbacks.
angular.module('vastdesk').
  component('playerControls', {
    bindings: {
      playing: '<',
      muted: '<',
      currentTime: '<',
      duration: '<',
      onPlayPause: '&',
      onMute: '&'
    },
    template:
      '<div class="player-controls">' +
        '<button type="button" class="player-controls-btn" ng-click="$playerControlsCtrl.onPlayPause()" aria-label="{{$playerControlsCtrl.playing ? \'Pause\' : \'Play\'}}">{{$playerControlsCtrl.playing ? \'❚❚\' : \'▶︎\'}}</button>' +
        '<button type="button" class="player-controls-btn" ng-click="$playerControlsCtrl.onMute()" aria-label="{{$playerControlsCtrl.muted ? \'Unmute\' : \'Mute\'}}">{{$playerControlsCtrl.muted ? \'🔇\' : \'🔊\'}}</button>' +
        '<span class="player-controls-time">{{$playerControlsCtrl.formatTime($playerControlsCtrl.currentTime)}} / {{$playerControlsCtrl.formatTime($playerControlsCtrl.duration)}}</span>' +
        '<div class="player-controls-progress">' +
          '<div class="player-controls-progress-fill" ng-style="{width: $playerControlsCtrl.progressPercent() + \'%\'}"></div>' +
        '</div>' +
      '</div>',
    controllerAs: '$playerControlsCtrl',
    controller: [function() {

      var self = this;

      self.formatTime = function(seconds) {
        if (!isFinite(seconds) || seconds < 0) {
          return '0:00';
        }
        var total = Math.floor(seconds);
        var mins = Math.floor(total / 60);
        var secs = total % 60;
        return mins + ':' + (secs < 10 ? '0' + secs : secs);
      };

      self.progressPercent = function() {
        if (self.duration > 0) {
          return Math.min(100, (self.currentTime / self.duration) * 100);
        }
        return 0;
      };

    }]
  });
